let TextEditor = {};

TextEditor.init = function() {
	let readMore = $('.js-read-more');
	let btnReadMore = $('.btn-read-more');

	if (readMore.length === 0){
		return;
	}

	readMore.each(function(){
		let thisReadMore = $(this);
		let thisTextHeight = thisReadMore.find('.editor-content-text').height();

		if (thisTextHeight > 150){
			thisReadMore.addClass('collapse-read-more');
		}
	});

	btnReadMore.click(function(){
		let thisReadMoreBtn = $(this);
		let editorContentCont = thisReadMoreBtn.closest('.js-read-more');
		let hasCollapse = editorContentCont.hasClass('collapse-read-more');

		if(hasCollapse){
			editorContentCont.removeClass('collapse-read-more');
			editorContentCont.addClass('expand-read-more');
		} else {
			editorContentCont.addClass('collapse-read-more');
			editorContentCont.removeClass('expand-read-more');
			
		}

	});
	
}

TextEditor.init();



// WEBPACK FOOTER //
// ./scripts/components/text-editor.js